import { render, staticRenderFns } from "./device-cards.vue?vue&type=template&id=f457310c&scoped=true&"
import script from "./device-cards.vue?vue&type=script&lang=js&"
export * from "./device-cards.vue?vue&type=script&lang=js&"
import style0 from "./device-cards.vue?vue&type=style&index=0&id=f457310c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f457310c",
  null
  
)

export default component.exports